export {
    default,
    getServerSideProps,
} from '../../../../util/search/pages/learn';
